import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { IAlertNotificationRepository } from '@/api/fe-api/domain/repositories/alert-notification-respository';

export namespace GetRuleList {
  export const key = (input: Input) => [
    'alert-notifications',
    'get-rule-list',
    ...Object.entries(input).flatMap(([key, value]) => [key, value]),
  ];

  export type Params = { refetchInterval?: number };
  export type Input = IAlertNotificationRepository.GetAllInput;
  export type Output = IAlertNotificationRepository.GetAllOutput;

  export function useQuery(
    input: Input = {},
    { refetchInterval }: Params = {},
  ) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input),
      queryFn: () => repositories.alertNotification.getAll(input),
    });
  }
}
